/**
 * List of static Intercom targets used for tracking user interactions in the application.
 * These targets are used to identify specific elements or actions within the app for analytics purposes.
 *
 * Naming convention for targets: [screen].[section].[action-or-descriptor]
 * - [screen]: The main area or page of the app (e.g., dashboard, settings).
 * - [section]: A specific part of the screen (e.g., header, billing).
 * - [action-or-descriptor]: The user action or element descriptor (e.g., invite-team, upgrade-plan).
 */
export const INTERCOM_TARGETS = {
  DASHBOARD_ADD_WIDGET_BUTTON: "dashboard.widget.add-widget-button",
} as const;

/**
 * Generates an Intercom dynamic targets.
 *
 * Naming convention for dynamic targets: [component].[context].[identifier]
 * - [component]: The reusable component or element type (e.g., sidebar.nav).
 * - [context]: The specific context or area where the component is used (e.g., route name).
 * - [identifier]: A unique identifier for the instance (e.g., route path).
 *
 * Example usage: intercomTarget.sidebarNav("dashboard") => "sidebar.nav.dashboard"
 * This allows tracking interactions with specific sidebar navigation items based on their route.
 */
export const intercomTarget = {
  sidebarNav: (identifier: string) => `sidebar.nav.${identifier}`,
  dashboardWidgetGrid: (index: number) => `dashboard.widget.grid-position-${index}`,
};
